import { useEffect, useRef, useState } from "react";
import UserApiService from "../../../../../services/apiServices/UserApiService";

export function useSellerContact(
  sellerId: string,
  contactMode: "AUTO" | "MANUAL",
  phoneFromProduct: string
): string {
  const [phone, setPhone] = useState<string>(phoneFromProduct);
  const didFetchRef = useRef(false);

  useEffect(() => {
    if (didFetchRef.current) return;
    if (contactMode !== "AUTO") return;
    if (!sellerId) return;
    didFetchRef.current = true;
    UserApiService.getUserPhoneById(sellerId)
      .then((fetched) => {
        if (fetched) setPhone(fetched);
      })
      .catch(() => {});
  }, [sellerId, contactMode]);

  return phone;
}
